import React from "react";
import styles from "./Layout.module.styl";
import SectionErrorBoundary from "../SectionErrorBoundary/SectionErrorBoundary";
import { PageHeader } from "../PageHeader/PageHeader";
import { AppDevTools } from "../AppDevTools/AppDevTools";

function Layout({ children, isAuthenticated }) {
    return (
        <div className={styles.root}>
            <PageHeader enableLogout={isAuthenticated} />
            <SectionErrorBoundary>
                <div className={styles.content}>{children}</div>
            </SectionErrorBoundary>
            <AppDevTools />
        </div>
    );
}

export default Layout;
